var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 128.000000 128.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 1271 c-11 -5 -29 -19 -40 -31 -20 -22 -20 -36 -20 -601 l0 -579 28 -27 27 -28 478 0 477 0 62 29 c151 70 234 245 189 401 -28 96 -87 169 -168 211 l-48 24 0 168 0 167 -138 138 -137 137 -345 -1 c-190 0 -354 -4 -365 -8z m675 -115 l0 -75 -47 -3 c-40 -3 -48 -6 -48 -23 0 -17 8 -20 49 -23 38 -3 58 -10 83 -33 32 -28 38 -29 128 -29 l95 0 0 -142 0 -143 -73 0 c-133 -1 -246 -75 -304 -200 -23 -50 -28 -73 -28 -140 0 -102 34 -183 106 -250 l48 -45 -331 0 c-294 0 -333 2 -350 17 -17 15 -18 46 -18 571 0 503 2 557 17 574 15 17 39 18 345 18 l328 0 0 -74z m154 -134 c-92 -4 -104 8 -104 102 l0 71 85 -85 86 -85 -67 -3z m142 -403 c243 -91 256 -436 20 -541 -71 -31 -172 -31 -243 1 -97 43 -173 160 -173 266 0 93 68 213 144 252 89 47 168 53 252 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 1067 c-2 -7 -3 -62 -2 -123 l3 -109 190 0 190 0 0 120 0 120 -188 3 c-149 2 -189 0 -193 -11z m336 -112 l0 -75 -145 0 -145 0 0 75 0 75 145 0 145 0 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 865 c-11 -30 12 -36 128 -33 106 3 114 4 114 23 0 19 -8 20 -118 23 -100 2 -118 0 -124 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 665 c-3 -9 -1 -21 4 -26 5 -5 88 -8 199 -7 181 3 189 4 189 23 0 19 -8 20 -193 23 -168 2 -193 0 -199 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 664 c-8 -21 13 -42 28 -27 13 13 5 43 -11 43 -6 0 -13 -7 -17 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 465 c-3 -9 -1 -21 4 -26 5 -5 86 -8 194 -7 176 3 184 4 184 23 0 19 -8 20 -188 23 -164 2 -188 0 -194 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 266 c-9 -10 -8 -16 4 -26 19 -16 41 1 32 24 -8 20 -21 20 -36 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 265 c-11 -30 12 -36 143 -33 121 3 129 4 129 23 0 19 -8 20 -133 23 -114 2 -133 0 -139 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 466 c-73 -73 -84 -88 -73 -101 7 -8 28 -15 46 -15 l34 0 0 -89 c0 -101 0 -101 85 -101 85 0 85 0 85 101 l0 89 34 0 c18 0 39 7 46 15 10 12 0 27 -61 91 -41 42 -82 80 -92 86 -16 8 -33 -4 -104 -76z m142 -26 c34 -35 36 -40 18 -40 -28 0 -33 -17 -33 -111 l0 -79 -35 0 -35 0 0 79 c0 94 -5 111 -33 111 -18 0 -16 5 18 40 21 22 44 40 50 40 6 0 29 -18 50 -40z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPublish);
export default __webpack_public_path__ + "static/media/jobPublish.a40c999284588d2e993c5fa0dba751e8.svg";
export { ForwardRef as ReactComponent };